import { DataEntrySourceModel } from '../data-entry-source';
import {
  ExpressionTypeEnum,
  FieldOperatorTypeEnum,
} from '../expression-type.enum';
import { Where } from '../filter.model';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { RefProperty } from '../ref-property.model';
import { FieldPresenterModel } from './field-presenter.model';

export interface FilterExpressionValue {
  type: FilterExpressionValueTypeEnum;
  value: Date | string | number | RefProperty | boolean;
}
export enum FilterExpressionValueTypeEnum {
  Fixed = 0,
  Pointer,
  Expression,
  Dynamic,
  Parameter,
}

export enum FilterExpressionPointer {
  Me = '@me',
  Now = '@now',
  Today = '@today',
  StartOfDay = '@StartOfDay',
  StartOfWeek = '@StartOfWeek',
  StartOfMonth = '@StartOfMonth',
  StartOfYear = '@StartOfYear',
  myOrgUnit = '@myOrgUnit',
  MyGroupsUsers = '@myGroupsUsers',
  MyGroups = '@myGroups',
  thisReference = '@thisReference',
  current_user = '@current_user',
  MyUsersGroups = '@myUsersGroups',
  MyOUGroups = '@myOUGroups',
  MyRoles = '@myRoles',
}

export interface FilterExpressionPresenterModel {
  field?: string;
  fieldOperator?: FieldOperatorTypeEnum;
  operator: ExpressionTypeEnum;
  args: FilterExpressionPresenterModel[] | FilterExpressionValue[] | any[];
}

export class DataQueryPresenterModel {
  id?: string;
  specificationVersion?: number;
  name: LocalizedValueModel;
  dataEntity: string;
  dataSource: DataEntrySourceModel;
  criteria: FilterExpressionPresenterModel;
  parameters?: DataQueryParameterPresenterModel[];
  isParameterized?: boolean;
  renderedCriteria?: Where<any>;
  useInQuickFilter?: boolean;
  tag?: QueryTagPresenterModel;
  updateIdentifier?: string;
}

export class DataQueryParameterPresenterModel {
  name: string;
  field: FieldPresenterModel;
  fieldEntityId: string;
}

export class SupportMultiOptionsModel {
  enabled: boolean;
  allowChangeMinMax: boolean;
  defaultMin: number;
  defaultMax?: number;
  label?: string;
}
export class QueryTagPresenterModel {
  enabled: boolean;
  name?: LocalizedValueModel;
  color?: string;
  icon?: IconModel;
  tagGroup?: string | null;
  tagGroupName?: null | LocalizedValueModel;
}
export class AllTagsPresenterModel {
  color: string;
  dataEntity: string;
  id?: string;
  isTagGroup: boolean;
  name: LocalizedValueModel;
  icon?: IconModel;
  tagGroup?: string;
}

export class TagGroupPresenterModel {
  color: string;
  dataEntity: string;
  id?: string;
  name: LocalizedValueModel;
}
